import Flex from "common/Boxes/Flex.tsx";
import Checkbox from "common/Checkbox/Checkbox.tsx";
import React, { ReactNode, useContext } from "react";
import { SymbolOption } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/types.ts";
import { MultiSymbolMarginContext } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/MultiSymbolMargin.context.ts";
import Tooltip from "common/Tooltips/Tooltip.tsx";
import { ContactWeb } from "common/Icons/Icons.tsx";
import Text from "common/Typography/Text.tsx";
import styled from "styled-components";

interface SymbolRowProps {
  data: SymbolOption;
}

const SymbolRow = ({ data }: SymbolRowProps) => {
  const { isViewOnly, isSymbolsOnly } = useContext(MultiSymbolMarginContext)!;

  const getSymbolMarginPreview = (symbolData: SymbolOption) => {
    const { marginDisplay } = symbolData;
    let displayText: ReactNode;
    if (typeof marginDisplay === "string") {
      displayText = (
        <SymbolRowText
          style={{
            color: symbolData.color,
          }}
        >
          {marginDisplay}
        </SymbolRowText>
      );
    } else {
      displayText = (
        <>
          {marginDisplay?.marginType} -
          <SymbolRowText
            style={{
              marginLeft: 4,
              color: symbolData.color,
            }}
          >
            {marginDisplay?.multiplier}
          </SymbolRowText>
        </>
      );
    }
    return (
      <SymbolRowText style={{ display: "flex", alignItems: "center" }}>
        {symbolData.isGlobalSettingsSymbol && (
          <Tooltip title="Using global settings">
            <ContactWeb style={{ marginRight: 6 }} />
          </Tooltip>
        )}
        {displayText}
      </SymbolRowText>
    );
  };

  return (
    <CheckboxRow
      onClick={isViewOnly ? undefined : data.onClick}
      key={data.symbol}
      $hasPendingChanges={data.hasPendingChanges}
      $isViewOnly={isViewOnly}
    >
      <Flex>
        {!isViewOnly && (
          <Checkbox
            checked={data.isSelected}
            style={{ marginRight: 12 }}
            $size={18}
          />
        )}
        <SymbolRowText>{data.symbol}</SymbolRowText>
      </Flex>
      {!isSymbolsOnly && (
        <SymbolRowText>{getSymbolMarginPreview(data)}</SymbolRowText>
      )}
    </CheckboxRow>
  );
};

export default React.memo(SymbolRow);

const CheckboxRow = styled.div<{
  $hasPendingChanges: boolean;
  $isViewOnly?: boolean;
}>`
  display: flex;
  align-items: center;
  ${(p) => !p.$isViewOnly && `cursor: pointer;`};
  justify-content: space-between;
  color: ${(p) =>
    p.$hasPendingChanges
      ? p.theme.colors.primaryBlue
      : p.theme.colors.primaryText};
`;
const SymbolRowText = styled(Text).attrs({ as: "div" })`
  color: inherit;
  transition: none;
`;
